import { css } from "@linaria/core";
import cx from "classnames";
import { styled } from "@linaria/react";
import cn from "classnames";
import type { SetStateAction } from "react";
import React from "react";
import ArrowDownSLine from "@ui/IconV2/react/ArrowDownSLine";
import Menu from "@ui/Menu";
import Option from "@ui/Option";
import Text from "@ui/Text";
import { colors, fonts } from "@ui/Theme";
import { HIDE_ON_WIDGET_EXPORT } from "@ui/ExportWidgetButton";

const Selection = styled.button`
  align-items: center;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid ${colors.titanium100};
  cursor: pointer;
  display: flex;
  font: ${fonts.body2SemiBold};
  height: 32px;
  justify-content: space-between;
  min-width: 140px;
  padding: 0 8px;
`;

const ZRotate = css`
  transform: rotateZ(180deg);
`;

const OverflowAuto = css`
  /* overflow: auto; */
  /* max-height: inherit; */
`;

const OverflowFixedHeight = css`
  max-height: 250px;
  /* overflow: hidden; */
`;

interface ReportingChartMenuProps<T extends string> {
  options: { label: string; value: T }[];
  currentValue: string;
  setCurrentValue: (
    value: SetStateAction<ReportingChartMenuProps<T>["options"][number]["value"]>,
  ) => void;
}

function ReportingChartMenu<T extends string>({
  options,
  currentValue,
  setCurrentValue,
}: ReportingChartMenuProps<T>) {
  const [menuOpened, setMenuOpened] = React.useState(false);
  const selection = React.useMemo(
    () => options.find(({ value }) => value === currentValue)?.label,
    [options, currentValue],
  );

  return (
    <Menu
      arrowWidth={0}
      //   gap={1}
      opened={menuOpened}
      setOpened={setMenuOpened}
      className={cx(OverflowFixedHeight, HIDE_ON_WIDGET_EXPORT)}
      overlay={
        <div className={OverflowAuto}>
          {options.map(({ label, value }) => (
            <Option
              key={value}
              selected={currentValue === value}
              closeOnClick
              onClick={() => setCurrentValue(value)}
            >
              {label}
            </Option>
          ))}
        </div>
      }
    >
      <Selection type="button" className={HIDE_ON_WIDGET_EXPORT}>
        <Text as="p" type="body2SemiBold">
          {selection}
        </Text>
        <ArrowDownSLine className={cn({ [ZRotate]: menuOpened })} />
      </Selection>
    </Menu>
  );
}

export default React.memo(ReportingChartMenu) as typeof ReportingChartMenu;
